import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SCHOOL_LAB_SETUP_CREATE } from "../apiRoutes";

export interface CreateLabSetupRequest {
  schoolId: string;
  targetDate: string;
  noOfWorkstations: number;
  specialRequirements?: string;
  labSetupStatus: string;
  comment?: string;
}

export interface CreateLabSetupResponse {
  data: any;
}

export const useCreateLabSetupMutation = ({ onSuccess, onError }: { onSuccess?: (data: CreateLabSetupResponse) => void; onError?: (e: any) => void; } = {}) => {
  const queryClient = useQueryClient();

  return useMutation<CreateLabSetupResponse, Error, CreateLabSetupRequest>({
    mutationFn: async (payload) => {
      const res = await axiosAuth.post<CreateLabSetupResponse>(SCHOOL_LAB_SETUP_CREATE, payload);
      return res.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["schoolLabSetup"] });
      onSuccess?.(data);
    },
    onError: (err) => onError?.(err),
  });
};
